module.exports = __webpack_public_path__ + "static/firenewt_warrior-64648231b3deea882277f468c6c85d42.jpeg";